import { IItemType, isNullOrUndefined } from '@bimser/core';
import IconBack from '@bimser/icons/16/back';
import IconHome from '@bimser/icons/16/home';
import IconRefresh from '@bimser/icons/16/refresh';
import IconTabNavRight from '@bimser/icons/16/tab-nav-right';
import * as React from 'react';
import {
	BCButton,
	BCInputSearch,
	BCScrollbars,
	BCSpaceCompact,
	IButtonClickEventArgs,
	IInputChangeEventArgs,
	IScrollbarsProps,
	findMessage
} from '..';
import FileExplorerItem from './FileExplorerItem';
import Style from './assets/style.scss';
import {
	FileExplorerHistoryItem,
	IFileExplorerItemClickEventArgs,
	IFileExplorerItemEvents,
	IFileExplorerItemProps,
	IFileExplorerProps,
	IFileExplorerState,
	IFileExplorerToolbar
} from './entities';

const searchBarStyle: React.CSSProperties = { width: '250px', marginLeft: 10, float: 'left' };
const toolbarGroupStyle: React.CSSProperties = { width: 'calc(100% - 260px)', float: 'left' };

const BCFileExplorer = (props: IFileExplorerProps) => {
	const scrollbarProps = React.useRef<IScrollbarsProps>({
		styles: {
			height: '385px',
			width: '100%'
		}
	});

	React.useEffect(() => {
		if (props.scrollbarProps) {
			scrollbarProps.current = props.scrollbarProps;
		}
	}, [props.scrollbarProps]);

	const onChangeSelection = (item?: IFileExplorerItemProps) => {
		if (props.onChangeSelection) {
			if (!isNullOrUndefined(item)) {
				props.onChangeSelection({
					...item,
					path: item && item.path ? item.path + '/' + item.text : item.text
				});
			} else {
				props.onChangeSelection(null);
			}
		}
	};

	const onReload = (e: IButtonClickEventArgs) => {
		e.event.stopPropagation();
		if (props.onReload) {
			props.onReload();
		}
	};

	const onItemClick = (args: IFileExplorerItemClickEventArgs) => {
		onChangeSelection(args.data);
	};
	const onItemDoubleClick = (args: IFileExplorerItemClickEventArgs) => {
		if (props.onOpenItem) {
			const path =
				args.data.path && args.data.path.length > 0
					? args.data.path + '/' + args.data.text
					: args.data.text;
			props.onOpenItem({
				...args.data,
				path
			});
		}
	};

	const onBodyClick = () => {
		onChangeSelection(null);
	};

	const getItems = () => {
		if (props.items) {
			return props.items.map(item => (
				<FileExplorerItem
					key={item.id}
					id={item.id}
					icon={item.icon}
					text={item.text}
					type={item.type}
					selected={item.selected}
					secretKey={item.secretKey}
					dataRef={item.dataRef}
					onClick={onItemClick}
					onDoubleClick={onItemDoubleClick}
					path={item.path || ''}
					fullPath={item.fullPath}
					extension={item.extension}
				/>
			));
		}
	};

	const renderItems = () => <div className={Style.fileExplorerItemContainer}>{getItems()}</div>;
	const onClickToolbarButton = (e: IButtonClickEventArgs) => {
		e.event.stopPropagation();
		if (props.onClickUp) {
			props.onClickUp();
		}
	};

	const onPathClick = (
		e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
		data: FileExplorerHistoryItem
	) => {
		e.stopPropagation();
		if (props.onPathClick && data) {
			props.onPathClick(data);
		}
	};

	const overridePathDisplay = () => {
		const pathArr = props.path.split('/').filter(Boolean);

		return pathArr.map(i => (
			<div key={i}>
				<IconTabNavRight />
				<span
					title={i}
					onClick={e => {
						onPathClick(
							e,
							props.historyItems.find(h => h.name === i)
						);
					}}
				>
					{i}
				</span>
			</div>
		));
	};

	const onClickRootPath = (e: IButtonClickEventArgs) => {
		e.event.stopPropagation();
		if (props.onOpenItem) {
			props.onClickRootPath();
		}
	};

	const renderToolbar = () => (
		<div className={Style.fileExplorerToolbar}>
			<BCSpaceCompact
				style={toolbarGroupStyle}
				className={Style.toolbarInputGroup}
				block
			>
				<BCButton
					title={findMessage.get('100709')} // Üst dizine çık
					disabled={!props.canGoUp}
					onClick={onClickToolbarButton}
					icon={<IconBack />}
					cssClass={Style.backBtn}
				/>
				<BCButton
					title={findMessage.get('100764')} // Main directory
					onClick={onClickRootPath}
					icon={<IconHome />}
					cssClass={Style.homeBtn}
				/>
				<div className={Style.fileExplorerPathbar}>{overridePathDisplay()}</div>
				<BCButton
					title={findMessage.get('100025')} // Yenile
					onClick={onReload}
					icon={<IconRefresh />}
					cssClass={Style.refreshBtn}
				/>
			</BCSpaceCompact>
			{renderSearchBar()}
		</div>
	);

	const onSearch = (args: any) => {
		const value: string = typeof args === 'string' ? args : args.data;
		if (props.onSearch) {
			props.onSearch(value);
		}
	};

	const renderSearchBar = () => (
		<BCInputSearch
			value={props.searchText}
			placeHolder={findMessage.get('100002')}
			style={searchBarStyle}
			onSearch={onSearch}
			onChange={onSearch}
			className={Style.inputSearch}
		/>
	);

	return (
		<div
			className={[Style.fileExplorerContainer].join(' ')}
			onClick={onBodyClick}
		>
			{renderToolbar()}
			{props.useScrollbar ? (
				<BCScrollbars
					{...scrollbarProps.current}
					cssClass={Style.scrollbarContainer}
				>
					{renderItems()}
				</BCScrollbars>
			) : (
				renderItems()
			)}
		</div>
	);
};
export default BCFileExplorer;
export {
	IFileExplorerItemClickEventArgs,
	IFileExplorerItemEvents,
	IFileExplorerItemProps,
	IFileExplorerProps,
	IFileExplorerState,
	IFileExplorerToolbar,
	IInputChangeEventArgs,
	IItemType
};
